import { useLocation, useMatches } from "react-router";
import { Breadcrumb } from "antd";
import { Link } from "react-router";

export default function () {
  const matches = useMatches();
  console.log(matches);
  const breadCumbItems = matches
    .filter((match) => match.handle?.crumb)
    .map((match, index, arr) => {
      const res =
        typeof match.handle.crumb === "function"
          ? match.handle.crumb(match.loaderData)
          : match.handle.crumb;
      return {
        title:
          index === arr.length - 1 ? (
            res
          ) : (
            <Link to={match.pathname}>{res}</Link>
          ),
      };
    });

  return <Breadcrumb items={breadCumbItems} />;
}
